import styled from 'styled-components';

const PagiNation = styled.ul`
    margin:0px;
    padding:0px;
    float:right;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        margin-bottom:20px;
    };
    li{
        display:inline-block;
        list-style:none;
        cursor: pointer;
        span{
            text-decoration:none;
            width:40px;
            height:40px;
            line-height:40px;
            text-align:center;
            background: ${(props) => props.theme.whiteColor};
            margin-left:2px;
            display:inline-block;
            color: ${(props) => props.theme.blackColor};
            &:hover{
                background:${(props) => props.theme.lightGray};
            }
            &.active{
                background:${(props) => props.theme.lightGray};
            }
        }

    }
`;

export default PagiNation;



// WEBPACK FOOTER //
// client/components/Pagination/StyledPagination.js